import ReportViewer, {
  accountxReportUrl,
} from '@account-root/account-react/src/containers/DigitalReportModule/ReportViewer';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import { useHistory, useLocation } from 'react-router';
import { formatDashDate } from 'helpers/StringNumberFunction/FormatDate';
import React from 'react';

export const FADepreciationReport = () => {
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem('loggedInUser'));
  const accountID = user.accountID;
  let location = useLocation();
  const editData = location?.state as any;

  const parameters = [
    { name: 'accountid', value: accountID },
    { name: 'companyid', value: editData?.CompanyID },
    { name: 'assettype', value: editData?.AssetType },
    { name: 'p_docno', value: editData?.DocNo },
    { name: 'p_assetcardno', value: editData?.AssetCardNo },
    { name: 'costcentreid', value: editData?.CostCentreID },
    { name: 'locationid', value: editData?.LocationID },
    {
      name: 'startdate',
      value: editData?.TranStartDate
        ? formatDashDate(new Date(editData?.TranStartDate).toISOString())
        : null,
    },
    {
      name: 'enddate',
      value: editData?.TranEndDate
        ? formatDashDate(new Date(editData?.TranEndDate).toISOString())
        : null,
    },
    {
      name: 'regstartdate',
      value: editData?.RegStartDate
        ? formatDashDate(new Date(editData?.RegStartDate).toISOString())
        : null,
    },
    {
      name: 'regenddate',
      value: editData?.RegEndDate
        ? formatDashDate(new Date(editData?.RegEndDate).toISOString())
        : null,
    },
  ];

  const generatedurl = (reportName, parameters) => {
    let reporturl = reportName;

    parameters?.map((x, index) => {
      const symbol = index === 0 ? '?' : '&';
      if (x?.value !== undefined)
        reporturl = reporturl + symbol + x?.name + '=' + x?.value;
    });
    return reporturl;
  };

  return (
    <>
      <MainHeader
        onClick={() => history.push(`/digital-reports/fixed-assets`)}
        mainBtn="close"
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Submenu' },
          { name: 'Parameters' },
          { name: 'Fixed Assets Depreciation Report', current: true },
        ]}
        rightRouteSegments={[{ name: 'Report', current: true }]}
      />
      <ContentWrapper style={{ maxHeight: '100%' }}>
        {ReportViewer({
          url: generatedurl('FADepreciationReport', parameters),
          host: accountxReportUrl,
          excludedExportFormat: [],
        })}
      </ContentWrapper>
    </>
  );
};
